<template>
  <div>
    <v-app-bar dense fixed color="white" height="70">
      <router-link to="/">
        <base-img
          :src="require('@/assets/myeduvisa-logo.png')"
          contain
          max-width="230"
          width="100%"
          id="logo"
        />
      </router-link>

      <v-spacer />

      <div>
        <v-tabs
          class="hidden-sm-and-down"
          color="green darken-2"
          background-color="transparent"
          optional
        >
          <v-tab
            to="/"
            class="font-weight-bold black--text tab"
            min-width="96"
            text
          >
            Home
          </v-tab>

          <v-tab
            to="/about-us"
            class="font-weight-bold black--text tab"
            min-width="6"
            text
          >
            about us
          </v-tab>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                to="/"
                class="font-weight-bold black--text tab"
                min-width="96"
                text
                v-bind="attrs"
                v-on="on"
              >
                Study<v-icon color="black" size="20"> mdi-menu-down </v-icon>
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab>
                    <a href="/study-singapore" target="_blank"
                      ><b>Singapore</b></a
                    ></v-tab
                  >
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b>Malaysia</b> </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"> <b>Uk</b></v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                to="/"
                class="font-weight-bold black--text tab"
                min-width="6"
                text
                v-bind="attrs"
                v-on="on"
              >
                visit<v-icon color="black" size="20"> mdi-menu-down </v-icon>
              </v-tab>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b> Singapore</b></v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"> <b>Malaysia</b></v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b> USA</b> </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                to="/"
                class="font-weight-bold black--text tab"
                min-width="96"
                text
                v-bind="attrs"
                v-on="on"
              >
                services<v-icon color="black" size="20"> mdi-menu-down </v-icon>
              </v-tab>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b> Study</b></v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b>Visit</b> </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/"><b>How can we help?</b> </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tab
            to="/blog"
            class="font-weight-bold black--text tab"
            min-width="96"
            text
          >
            Blog
          </v-tab>

          <v-tab
            to="/contact-us"
            class="font-weight-bold black--text tab"
            min-width="96"
            text
          >
            Contact us
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
      <v-btn class="ma-2" outlined rounded color="green accent-4">
        <b> Hiring</b>
      </v-btn>
      <!-- <v-btn rounded color="primary" dark> free consultation </v-btn>-->
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

  <script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer"),
  },

  data: () => ({
    drawer: null,
    items: ["Home", "About", "Study Singapore", "Services", "Blog", "Contact"],
  }),
};
</script>

  <style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto
    .v-tab
      &::before
        display: none
</style>
  <style  scoped>
#logo {
  cursor: pointer;
}
@media only screen and (max-width: 600px) {
  #bookNow {
    display: none;
  }
}
.tab {
  font-size: 10px;
}
a {
  text-decoration: none;
  color: rgb(31, 31, 31);
}
</style>

